/**
 * Composer dot phrases: `.` plus a trigger opens a menu above the chat
 * composer. The chat renders `DotPhraseMenu` with what `useDotPhraseMenu`
 * returns; another feature adds an action phrase, such as `.draft`, through
 * the hook's `actionPhrases`, typed from the `/model` entry.
 */
export { useDotPhraseMenu } from './hooks/useDotPhraseMenu';
export { DotPhraseMenu } from './ui/DotPhraseMenu';
